import sendBasketReq from './helpers/basketFetch';

const initScripts = () => {
  window.cartInit();
  window.initClearBasketItem();
  window.initImportFileHandler();
  window.initShareBasket();
  window.initBasketGetOffer();
  window.basketCouponsInit();
  window.spollerUpd();
  window.initDropMenuButtons();
  window.popupsInit();
};

const submitButtonHandler = async () => {
  const couponInput = document.querySelector('[data-entity="basket-coupon-input"]');
  if (couponInput) {
    const coupon = couponInput.value;
    if (coupon) {
      const formData = new FormData();
      formData.append('basket[coupon]', coupon);
      formData.append('basketAction', 'refreshAjax');

      const response = await sendBasketReq(formData);
      if (response) {
        const html = document.createElement('div');
        html.innerHTML = response;
        document.querySelector('#basket-container').innerHTML = html.querySelector('#basket-container').innerHTML;

        initScripts();
      }
    }
  }
};

const deleteButtonHandler = async () => {
  const couponElem = document.querySelector('[data-entity="basket-coupon"]');
  if (couponElem) {
    const coupon = couponElem.innerHTML;
    if (coupon) {
      const formData = new FormData();
      formData.append(`basket[delete_coupon][${coupon}]`, coupon);
      formData.append('basketAction', 'refreshAjax');

      const response = await sendBasketReq(formData);
      if (response) {
        const html = document.createElement('div');
        html.innerHTML = response;
        document.querySelector('#basket-container').innerHTML = html.querySelector('#basket-container').innerHTML;

        initScripts();
      }
    }
  }
};

const init = () => {
  const submitButton = document.querySelector('.side-cart__sales-promo-button');
  if (submitButton && !submitButton.classList.contains('_init')) {
    submitButton.addEventListener('click', submitButtonHandler);
    submitButton.classList.add('_init');
  }

  const deleteButton = document.querySelector('[data-entity="basket-coupon-delete"]');
  if (deleteButton && !deleteButton.classList.contains('_init')) {
    deleteButton.addEventListener('click', deleteButtonHandler);
    deleteButton.classList.add('_init');
  }
};

init();

window.basketCouponsInit = init;
